/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VwbGroupMember } from './VwbGroupMember';
import {
    VwbGroupMemberFromJSON,
    VwbGroupMemberFromJSONTyped,
    VwbGroupMemberToJSON,
} from './VwbGroupMember';

/**
 * 
 * @export
 * @interface VwbGroupMemberListResponse
 */
export interface VwbGroupMemberListResponse {
    /**
     * 
     * @type {Array<VwbGroupMember>}
     * @memberof VwbGroupMemberListResponse
     */
    members: Array<VwbGroupMember>;
}

/**
 * Check if a given object implements the VwbGroupMemberListResponse interface.
 */
export function instanceOfVwbGroupMemberListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "members" in value;

    return isInstance;
}

export function VwbGroupMemberListResponseFromJSON(json: any): VwbGroupMemberListResponse {
    return VwbGroupMemberListResponseFromJSONTyped(json, false);
}

export function VwbGroupMemberListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbGroupMemberListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(VwbGroupMemberFromJSON)),
    };
}

export function VwbGroupMemberListResponseToJSON(value?: VwbGroupMemberListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'members': ((value.members as Array<any>).map(VwbGroupMemberToJSON)),
    };
}

